import React from "react";
import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import CustomPagingInfo from "./customPaging";
import { highlightText, truncateText } from './textUtils';

import {
  ErrorBoundary,
  Facet,
  SearchProvider,
  SearchBox,
  Results,
  PagingInfo,
  ResultsPerPage,
  Paging,
  Sorting,
  WithSearch
} from "@elastic/react-search-ui";
import { Layout } from "@elastic/react-search-ui-views";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import {
  buildAutocompleteQueryConfig,
  buildFacetConfigFromConfig,
  buildSearchOptionsFromConfig,
  buildSortOptionsFromConfig,
  getConfig,
  getFacetFields
} from "./config/config-helper";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});
const config = {
  searchQuery: {
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  alwaysSearchOnInitialLoad: true
};

export default function App() {
  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ wasSearched, searchTerm }) => ({ wasSearched, searchTerm })}>
        {({ wasSearched, searchTerm }) => {
          return (
            <div className="App">
              <ErrorBoundary>
                <Layout
                  bodyContent={
                    <Results
                      titleField={getConfig().titleField}
                      urlField={getConfig().urlField}
                      thumbnailField={getConfig().thumbnailField}
                      shouldTrackClickThrough={true}
                      resultView={({ result }) => {
                        const highlightedDescription = result.body_content ? 
                          highlightText(truncateText(result.body_content.raw || '', searchTerm, 50), searchTerm) : '';
                        const highlightedTitle = result.title ? highlightText(result.title.raw, searchTerm): '';
                        return (
                          <li className="sui-result">
                            <a className="sui-result__link" href={result.url.raw} target="" rel="noopener noreferrer">
                              <div className="sui-result__header">
                                <span className="sui-result__title" dangerouslySetInnerHTML={{ __html: highlightedTitle }}></span>
                              </div>
                              <div className="sui-result__body">
                                    <span className="sui-result__value" dangerouslySetInnerHTML={{ __html: highlightText(highlightedDescription) }}></span> 
                              </div>
                            </a>
                          </li>
                        );
                      }}
                    />
                  }
                  bodyHeader={
                    <div>
                      <h1 id="mainTitle">תוצאות חיפוש</h1>
                      {wasSearched && searchTerm && (
                        <div className="search-term-display">
                          <h2>תוצאות חיפוש עבור "{searchTerm}"</h2>
                        </div>
                      )}
                      {wasSearched && <CustomPagingInfo />}
                    </div>
                  }
                  bodyFooter={<Paging />}
                />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}